class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) {
      return;
    }

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      }
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.querySelectorAll(
      'button[type="button"]'
    ).forEach((button) => {

      if (
        button.classList.contains(
          'modal__close-button'
        )
      ) {
        button.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

    });

    this.summaryToggle.setAttribute(
      'role',
      'button'
    );
  }

  isOpen() {
    return Boolean(
      this.detailsContainer &&
      this.detailsContainer.hasAttribute('open')
    );
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (!this.detailsContainer) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.detailsContainer) {
      return;
    }

    if (
      !this.contains(event.target) ||
      event.target.classList.contains(
        'modal-overlay'
      )
    ) {
      this.close(false);
    }
  }

  open(event) {
    if (
      !this.detailsContainer ||
      !this.summaryToggle
    ) {
      return;
    }

    this.onBodyClickEvent =
      this.onBodyClickEvent ||
      this.onBodyClick.bind(this);

    event?.target
      ?.closest('details')
      ?.setAttribute('open', true);

    this.detailsContainer.setAttribute(
      'open',
      true
    );

    document.body.addEventListener(
      'click',
      this.onBodyClickEvent
    );

    document.body.classList.add(
      'overflow-hidden'
    );

    this.detailsContainer
      .querySelector(
        '[tabindex="-1"]'
      )
      ?.focus();
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) {
      return;
    }

    this.detailsContainer.removeAttribute(
      'open'
    );

    document.body.removeEventListener(
      'click',
      this.onBodyClickEvent
    );

    document.body.classList.remove(
      'overflow-hidden'
    );

    if (
      focusToggle &&
      this.summaryToggle
    ) {
      this.summaryToggle.focus();
    }
  }
}

if (
  !customElements.get(
    'details-modal'
  )
) {
  customElements.define(
    'details-modal',
    DetailsModal
  );
}